import { render, staticRenderFns } from "./stockOverflowHistory.vue?vue&type=template&id=96d8b938&scoped=true"
import script from "./stockOverflowHistory.vue?vue&type=script&lang=js"
export * from "./stockOverflowHistory.vue?vue&type=script&lang=js"
import style0 from "./stockOverflowHistory.vue?vue&type=style&index=0&id=96d8b938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d8b938",
  null
  
)

export default component.exports